import { IShortcutListRequest } from 'core/model/interfaces/shortcuts';
import {
  ICreateShortcutRequest,
  IUpdateShortcutRequest,
} from 'core/model/interfaces/shortcuts/shortcuts-form.interface';
import { toPriceGroupList } from '../master-entities/master-entities.mappers';
import { shortcutsData } from './shortcuts.data';
import {
  mapShortcutCreationRequest,
  mapShortcutListRequest,
  mapShortcutListResponse,
  mapShortcutUpdateRequest,
} from './shortcuts.mappers';

export const shortcutsService = {
  getShortcutList: async (params: IShortcutListRequest) => {
    const mappedParams = mapShortcutListRequest(params);
    const response = await shortcutsData.getShortcutList(mappedParams);

    const mappedResponse = mapShortcutListResponse(response);

    return mappedResponse;
  },

  createShortcut: async (data: ICreateShortcutRequest) => {
    const body = mapShortcutCreationRequest(data);

    const response = await shortcutsData.createShortcut(body);

    return response;
  },

  updateShortcut: async (params: IUpdateShortcutRequest) => {
    const body = mapShortcutUpdateRequest(params);
    const response = await shortcutsData.updateShortcut(body);

    return response;
  },

  deleteShortcut: async (id: number) => {
    const response = await shortcutsData.deleteShortcut(id);

    return response;
  },

  getShortcutPriceGroups: async (shortcutId?: number) => {
    const response = await shortcutsData.getShortcutPriceGroups(shortcutId);

    const { priceGroups } = response;

    const mappedResponse = toPriceGroupList(priceGroups);

    return mappedResponse;
  },
};
